import React, { useState } from "react";
import useGroupCreateHook from "./GroupCreate.hook";
import styles from "./Style.module.css";
import CustomTextField from "../../../../../components/FormFields/TextField/TextField.component";
import { Button, Checkbox } from "@material-ui/core";
import initialSelected from "../../../../../assets/img/ic_initial_selected@2x.png";
import initial from "../../../../../assets/img/ic_initial@2x.png";
import defaultImg from "../../../../../assets/img/ic_default_image@2x.png";
import defaultSelected from "../../../../../assets/img/ic_default_selected@2x (1).png";
import AddEmployeeTable from "./component/AddEmployee/AddEmployeeTable.component";

function GroupCreate({ groupId, handleSidePanelToggle, handleClosepopOver ,fetchChatInfo,setChatUser,setTabIndex}) {
  const {
    form,
    errorData,
    changeTextData,
    handleSubmit,
    editEmployee,
    isLoading,
  } = useGroupCreateHook({
    groupId,
    handleSidePanelToggle: handleSidePanelToggle,
    handleClosepopOver,
    fetchChatInfo,
    setChatUser,setTabIndex
  });
  return (
    <div className={styles.containerWrap}>
      <div className={styles.title}>Choose Display Image</div>
      <div className={styles.formWrp21}>
        <div>
          <div
            className={`${styles.option} ${
              form?.display_type === "IMAGE" ? styles.active : ""
            }`}
            onClick={() => changeTextData("IMAGE", "display_type")}
          >
            <div
              className={`${styles.imgWrapper} ${
                form?.display_type === "IMAGE"
                  ? styles.selectedBg
                  : styles.defaultBg
              }`}
            >
              <img
                src={
                  form?.display_type === "IMAGE" ? defaultSelected : defaultImg
                }
                alt="img"
                className={styles.img}
              />
            </div>
            <span className={styles.text}>Default Image</span>
          </div>
        </div>
        <div>
          <div
            className={`${styles.option} ${
              form?.display_type === "INITIALS" ? styles.active : ""
            }`}
            onClick={() => changeTextData("INITIALS", "display_type")}
          >
            <div
              //  className={styles.imgWrapper2}
              className={`${styles.imgWrapper2} ${
                form?.display_type === "INITIALS"
                  ? styles.selectedBgIn
                  : styles.defaultBgIn
              }`}
            >
              <img
                src={
                  form?.display_type === "INITIALS" ? initialSelected : initial
                }
                alt="img"
                className={styles.img2}
              />
            </div>
            <span className={styles.text}>Initials</span>
          </div>
        </div>
      </div>
      <div className={styles.formWrp}>
        <div className={styles.formGrp}>
          <CustomTextField
            isError={errorData?.name}
            errorText={errorData?.name}
            label={"Group Name"}
            value={form?.name}
            onTextChange={(text) => {
              changeTextData(text, "name");
            }}
          />
        </div>
      </div>
      <div className={styles.formWrp}>
        <div className={styles.formGrp}>
          <CustomTextField
            isError={errorData?.description}
            errorText={errorData?.description}
            label={"Description"}
            value={form?.description}
            onTextChange={(text) => {
              if (text?.length <= 500) {
                changeTextData(text, "description");
              }
            }}
            multiline
            rows={3}
          />
        </div>
      </div>
      <div className={styles.checkboxWrap}>
        <Checkbox
          style={{ padding: 0, marginRight: "10px" }}
          name={"form?.should_admin_only_send"}
          checked={form?.should_admin_only_send}
          onChange={() =>
            changeTextData(
              !form?.should_admin_only_send,
              "should_admin_only_send"
            )
          }
        />
        <div className={styles.des}>Only admins can send messages</div>
      </div>
      <AddEmployeeTable
        handleSubmit={handleSubmit}
        editEmployee={editEmployee}
        groupId={groupId}
        isLoading={isLoading}
      />
    </div>
  );
}

export default GroupCreate;
